"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function slr(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M9.31551 16.5C9.40326 16.773 10.4893 17.898 11.6195 17.898C13.295 17.898 14.2738 16.887 14.2738 15.4245C14.2738 14.07 13.5958 13.296 11.8828 12.543C9.81201 11.7045 8.53176 10.4782 8.53176 8.43525C8.53176 6.17775 10.1698 4.5 12.6358 4.5C13.9348 4.5 15.251 5.3175 15.6875 5.8635L14.6398 6.95475C14.2258 6.69675 13.7285 6.048 12.5795 6.048C10.8478 6.048 10.1885 7.23075 10.1885 8.22C10.1885 9.57525 10.961 10.242 12.7108 11.016C14.8573 11.9625 15.9493 13.1452 15.9493 15.2738C15.9493 17.511 14.4913 19.5 11.498 19.5C10.274 19.5 8.96676 18.6825 8.18076 17.682L9.31551 16.5ZM10.712 8.77275C10.4503 8.2275 10.625 7.68225 10.625 7.68225C17.258 6.591 16.0363 13.0448 16.0363 13.0448C15.5128 12.0457 14.9893 11.8635 14.9893 11.8635C15.0763 8.136 10.712 8.77275 10.712 8.77275ZM13.6798 14.682C13.9423 15.3188 13.6393 15.981 13.6393 15.981C6.08676 16.9545 8.12676 10.0485 8.12451 10.0485C8.52501 11.109 9.02301 11.3572 9.02301 11.3572C8.88051 15.6817 13.6798 14.682 13.6798 14.682Z", fill: color }));
}
exports["default"] = slr;
//# sourceMappingURL=slr.js.map